function phoneMask(input) {
    const iti = window.intlTelInput(input, {
        autoPlaceholder: 'aggressive',
        formatOnDisplay: false,
        initialCountry: 'ru',
        onlyCountries: ['ru', 'gb', 'gr', 'tr', 'us', 'ua', 'cy', 'ae', 'pt', 'au'],
        nationalMode: false,
        preferredCountries: ['gb', 'tr'], // страны вверху списка
        // excludeCountries: ['aq', 'bv'], // убрать страны из списка
        separateDialCode: true,
    });

    const phoneMask = IMask(input, {
        mask: '000 000 00 00',
    });


    const observer = new MutationObserver(() => {
        const dropdown = document.querySelector('.iti__country-list');
        if (dropdown && dropdown.offsetParent !== null) {
            document.body.classList.add('body-iti-open');
        } else {
            document.body.classList.remove('body-iti-open');
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });


    input.addEventListener('countrychange', function (e) {
        const target = e.target;
        target.value = '';
        phoneMask.value = '';

        const selectedCountry = iti.getSelectedCountryData();
        const dialCode = selectedCountry.dialCode;

        let maskNumber = intlTelInputUtils.getExampleNumber(selectedCountry.iso2, 0, 0);
        maskNumber = intlTelInputUtils.formatNumber(maskNumber, selectedCountry.iso2, 4);
        maskNumber = maskNumber.replace('+' + dialCode + ' ', '');
        let maskInput = maskNumber.replace(/[0-9+]/gi, '0');

        phoneMask.mask = maskInput;
    });

    input.addEventListener('blur', function () {
        if (iti.isValidNumber()) {
            input.parentNode.parentNode.classList.remove('is-invalid');
            input.parentNode.parentNode.classList.add('is-valid');
        } else {
            input.parentNode.parentNode.classList.add('is-invalid');
            input.parentNode.parentNode.classList.remove('is-valid');
        }
    });

    input.addEventListener('keyup', function () {
        if (iti.isValidNumber()) {
            input.parentNode.parentNode.classList.remove('is-invalid');
            input.parentNode.parentNode.classList.add('is-valid');
        }
    });
}

const inputTelArr = document.querySelectorAll('.js-input-tel');
if (inputTelArr.length > 0) {
    inputTelArr.forEach((inp) => {
        phoneMask(inp);

        inp.addEventListener('keydown', function (e) {
            if (e.key === '0' && inp.value.length === 0) {
                e.preventDefault();
                inp.value = '';
            }
        });

        inp.addEventListener('keyup', function (e) {
            if (inp.value.slice(0, 1) === '0') {
                inp.value = inp.value.slice(1);
            }
        });

        inp.addEventListener('blur', function (e) {
            if (inp.value.slice(0, 1) === '0') {
                inp.value = inp.value.slice(1);
            }
        });
    });
}

Fancybox.bind("[data-fancybox]", {
    dragToClose: false,
    autoFocus: false,
    placeFocusBack: false,
});